import Swiper from "swiper"
import { Navigation } from "swiper/modules"

function initCasesSwiper() {
	const swiperElement = document.querySelector(".cases-swiper")
	if (!swiperElement) return

	if ((swiperElement as any).swiper) {
		return
	}

	new Swiper(".cases-swiper", {
		modules: [Navigation],
		slidesPerView: 1,
		spaceBetween: 24,
		loop: false,
		navigation: {
			nextEl: ".swiper-button-next-custom",
			prevEl: ".swiper-button-prev-custom",
			disabledClass: "opacity-50 cursor-not-allowed"
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 32
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 40
			}
		},
		on: {
			init: function () {
				console.log("Cases carousel initialized with", this.slides.length, "slides")
			}
		}
	})
}

// iinit on DOM ready
if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initCasesSwiper)
} else {
	setTimeout(initCasesSwiper, 0)
}

// re-init on page navigation (for view transitions)
document.addEventListener("astro:page-load", initCasesSwiper)
